<template>
    <b-col v-if="resumen" class="mt-3" cols="12" id="resumen">
        <b-row v-if="!Array.isArray(resumen) || resumen.length > 0">
            <b-col cols="12">
                <h4>Resumen provisional:</h4>
            </b-col>

            <slot>
                <b-table v-if="fields?.length > 0" class="mx-3" striped hover :items="resumen" :fields="fields">
                    <template #cell(descripcion)="data">
                        <h5>{{ data.item.descripcion }}</h5>
                    </template>
                    <template #cell(total)="data">
                        {{ data.item.total }}
                    </template>
                    <template #cell(importe)="data">
                        {{ data.item.importe | formatear_precio }}
                    </template>
                </b-table>
            </slot>
            
            <b-col cols="12" class="mt-3">
                <h5>Total: {{ total | formatear_precio }}</h5>
            </b-col>
            <b-col cols="12" >
                <ContentOrLoading :style="creando ? 'padding-bottom: 100px;' : ''">
                    <b-button
                        v-if="!creando"
                        block 
                        @click="crearLiquidacion()"
                    >
                        Crear liquidación
                    </b-button>
                </ContentOrLoading>
            </b-col>
        </b-row>                            
        <b-col cols="12" class="alert alert-warning m-auto" role="alert" v-else>
            <b>No hay resumen de ninguno de los eventos seleccionados.</b>
        </b-col>
    </b-col>
</template>

<script>
export default {
    props: {
        resumen: {
            required: true
        },
        fields: {
            type: Array,
            required: false
        },
        creando: {
            type: Boolean,
            required: true
        },
        total: {
            type: Number,
            required: true
        }
    },
    methods: {
        crearLiquidacion() {
            return this.$emit('crearLiquidacion');
        }
    }
}
</script>